import React from 'react';
import sanjoy from "../../../images/sanjoy.jpg"

const TeamPerson = () => {
    return (
        <div className="col-xl-3 col-lg-3 col-md-6">
            <div className="team-wrapper team-wrapper-02 pos-rel mb-100">
                <div className="team-img pos-rel">
                    <div className="fix">
                        <img src={sanjoy} alt="Image not found " />
                    </div>
                </div>
                <div className="team-text">
                    <div className="team-text-inner-content fix">
                        <div className="team-inner-content">
                            <h5>Sanjoy Banik</h5>
                            <span>Web Developer </span>
                        </div>
                        <div className="team-icons">
                            <a className="twitter" href="#"><i className="fab fa-twitter"></i></a>
                            <a className="fb" href="#"><i className="fab fa-facebook-f"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamPerson;